import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import ErrorBoundary from "./components/ErrorBoundary.tsx";

console.log('🚀 Iniciando aplicação...');
console.log('📍 URL:', window.location.href);
console.log('🔑 VITE_SUPABASE_URL:', import.meta.env.VITE_SUPABASE_URL || '❌ UNDEFINED');
console.log('🔑 VITE_SUPABASE_PUBLISHABLE_KEY:', import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ? '✅ Presente (ocultado)' : '❌ UNDEFINED');
console.log('🔑 VITE_SUPABASE_PROJECT_ID:', import.meta.env.VITE_SUPABASE_PROJECT_ID || '❌ UNDEFINED');
console.log('📦 Todas as variáveis VITE_:', Object.keys(import.meta.env).filter(k => k.startsWith('VITE_')));

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
